<template>
  <div class="home">
    <nav class="fh5co-nav" role="navigation">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 text-center">
            <div id="fh5co-logo"><a href="" style="font-family: 'Oleo Script', Sans-serif;">Wedding Invitation<strong>.</strong></a></div>
          </div>
        </div>
        
      </div>
    </nav>

    <!-- ======= Header Section ======= -->
    <Header :client='client' :config='config'/>

    <!-- ======= Couple Section ======= -->
    <Couple :client='client' :config='config'/>

    <!-- ======= Event Section ======= -->
    <Event :client='client' :days='days' :hours='hours' :minutes='minutes' :seconds='seconds' :config="config"/>

    <!-- ======= Maps Location Section ======= -->
    <div v-if="config.maps_section !== 0" id="fh5co-couple-story">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
            <h2 style="font-family: 'Oleo Script', Sans-serif;" >{{ config.language === 1 ? 'Maps' : 'Peta Lokasi' }}</h2>
            
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-md-offset-0 animate-box text-center">
            <!-- <div class="col-12" style="border-radius: 10px; border-style: solid; border-width: 10px; border-color: #e79552; background-color: #eee; width: 100%; height: 250px" id="map"></div>
             -->
             <iframe class="ftco-animate" :src="client.embed" width="95%" height="450" style="border-radius: 20px !important; border-style: solid; border-width: 2px; border-color:#e79552; margin: auto; margin-top: 10px;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>                
        </div>
          <div class="col-md-12 col-md-offset-0 text-center">
              <div class="display-t">
                  <div class="display-tc animate-box" data-animate-effect="fadeIn">
                      <a :href="client.url_maps" target="_blank" class="btn btn-default btn-sm"><i class='fas fa-map-marker-alt' style='font-size:15px'></i>{{ config.language === 1 ? 'Open Map' : 'Buka Map' }}</a>
                  </div>
              </div>
          </div>
      </div>
    </div>

    <div v-if="config.story_section !== 0" id="fh5co-gallery">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
            <span>We Love Each Other</span>
            <h2 style="font-family: 'Oleo Script', Sans-serif;" >{{ config.language === 1 ? 'Our Story' : 'Kisah Kami' }}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-md-offset-0">
            <ul class="timeline animate-box">
              <li v-if="story.type1 !== undefined" class="media animate-box">
                <div class="timeline-badge" style="background-image:url(images/couple-1.jpg);"></div>
                <div class="timeline-media" v-if="story.media1.media !== null">
                  <img v-if="story.type1.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media1.media" width="100%" alt="">
                  <video v-if="story.type1.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media1.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">{{story.title1.title}}</h3>
                    <span class="date">{{story.month1.rangeTime}}</span>
                  </div>
                  <div class="timeline-body">
                    <p v-html="story.description1.description"></p>
                  </div>
                </div>
                
              </li>
              <li v-if="story.type2 !== undefined" class="timeline-inverted animate-box">
                <div class="timeline-badge" style="background-image:url(images/couple-2.jpg);"></div>
                <div class="timeline-media" v-if="story.media2.media !== null">
                  <img v-if="story.type2.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media2.media" width="100%" alt="">
                  <video v-if="story.type2.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media2.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">{{story.title2.title}}</h3>
                    <span class="date">{{story.month2.rangeTime}}</span>
                  </div>
                  <div class="timeline-body">
                    <p v-html="story.description2.description"></p>
                  </div>
                </div>
              </li>
              <li v-if="story.type3 !== undefined" class="media animate-box">
                <div class="timeline-badge" style="background-image:url(images/couple-3.jpg);"></div>
                <div class="timeline-media" v-if="story.media3.media !== null">
                  <img v-if="story.type3.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media3.media" width="100%" alt="">
                  <video v-if="story.type3.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media3.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">{{story.title3.title}}</h3>
                    <span class="date">{{story.month3.rangeTime}}</span>
                  </div>
                  <div class="timeline-body">
                    <p v-html="story.description3.description"></p>
                  </div>
                </div>
              </li>
              <li v-if="story.type4 !== undefined" class="timeline-inverted animate-box">
                <div class="timeline-badge" style="background-image:url(images/couple-2.jpg);"></div>
                <div class="timeline-media" v-if="story.media4.media !== null">
                  <img v-if="story.type4.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media4.media" width="100%" alt="">
                  <video v-if="story.type4.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media4.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">{{story.title4.title}}</h3>
                    <span class="date">{{story.month4.rangeTime}}</span>
                  </div>
                  <div class="timeline-body">
                    <p v-html="story.description4.description"></p>
                  </div>
                </div>
              </li>
              <li v-if="story.type5 !== undefined" class="media animate-box">
                <div class="timeline-badge" style="background-image:url(images/couple-3.jpg);"></div>
                <div class="timeline-media" v-if="story.media5.media !== null">
                  <img v-if="story.type5.type == 'foto'" :src="'https://admin.itsyourdayofficial.com/story/' + story.media5.media" width="100%" alt="">
                  <video v-if="story.type5.type == 'video'" width="100%" height="280px;" :src="'https://admin.itsyourdayofficial.com/story/' + story.media5.media +'#t=0.001'" type="video/mp4" controls preload="metadata"></video>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">{{story.title5.title}}</h3>
                    <span class="date">{{story.month5.rangeTime}} </span>
                  </div>
                  <div class="timeline-body">
                    <p v-html="story.description5.description"></p>
                  </div>
                </div>
              </li>             
            </ul>
          </div>
        </div>
      </div>
    </div>
    
    <!-- ======= Gallery Section ======= -->
    <!-- <Galerry  v-if="config.gallery_section !== 0" :client='client' :gallery='gallery' :config="config"/> -->
    <div v-if="config.gallery_section !== 0" id="fh5co-gallery" class="fh5co-section-gray">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
            <span>Our Memories</span>
            <h2 style="font-family: 'Oleo Script', Sans-serif; padding-bottom: 50px;">{{ config.language === 1 ? 'Photo Gallery' : 'Galeri Foto' }}</h2>
          </div>
        </div>
        <div class="row justify-content-center row-bottom-padded-md">
            <div class="col-md-12 animate-box elementor-element-6b397287">
                <vue-horizontal responsive :button="false" ref="horizontal" @scroll-debounce="onScroll">
                    <div class="item" v-for="(item, index) in gallery" :key="index">
                      <img
                          :src="'https://admin.itsyourdayofficial.com/gallery/' + item.file"
                          class="gallery img d-flex align-items-center justify-content-center"
                          alt="..."
                          @click="openLightbox(index)"
                      >
                      <div class="magnifier-icon" @click="openLightbox(index)">
                          <i class="fa fa-search-plus"></i>
                      </div>
                    </div>
                </vue-horizontal>
                <div class="pagination justify-content-center">
                    <nav>
                        <button @click="prev($event)"
                            :class="{ 'active': hasPrev, 'inactive': !hasPrev }">
                            <i class="lni lni-chevron-left"></i>
                        </button>
                        <button @click="next($event)" :class="{ 'active': hasNext, 'inactive': !hasNext }">
                            <i class="lni lni-chevron-right"></i>
                        </button>

                    </nav>
                </div>
            </div>
            <component
                v-if="Lightbox && lightboxVisible"
                :is="Lightbox"
                :visible="lightboxVisible"
                :imgs="imageList"
                :index="currentIndex"
                @hide="closeLightbox"
            />
        </div>  
      </div>
    </div>
    <Confirmation v-if="config.rsvp_by_wa_section !== 0" :client='client' :config="config"/>
    <Quotes :client='client'/>
    <AlsoInvitation v-if="config.invitation_section !== 0" :alsoInvite='alsoInvite' :config="config"/>
    <Angpao v-if="config.gift_section !== 0" :client='client' :config="config"/>

    <div id="fh5co-started" class="fh5co-bg" style="background-image:url(../assets/images/image2.jpg);">
      <div class="overlay"></div>
      <div class="container">
        <div class="row animate-box">
          <div class="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2 style="font-family: 'Oleo Script', Sans-serif;">{{ config.language === 1 ? "Wedding Wish" : 'Ucapan Pernikahan' }}</h2>
            <p>{{ config.language === 1 ? "Send Prayers & Greetings to the Bride and Groom" : 'Kirimkan Doa & Ucapan Kepada kedua Mempelai' }}</p>
          </div>
        </div>
        <div class="row animate-box">
          <div class="col-md-10 col-md-offset-1">
            <form class="form-inline">
              <div class="col-md-8 col-md-offset-2">
                <div class="form-group">
                  <!-- <label for="name" class="sr-only">Nama</label> -->
                  <input type="name" v-model="submit.client_id" hidden>
                </div>
                <div class="form-group">
                  <label for="name" class="sr-only">{{ config.language === 1 ? "Name" : 'Nama' }}</label>
                  <input type="name" v-model="submit.name" class="form-control" id="name" :placeholder="config.language === 1 ? 'Name' : 'Nama'" autocomplete="off" required>
                </div>
                <span v-if="errors.name" style="margin-bottom:10px" class="badge badge-danger">
                  {{ config.language === 1 ? "Please fill in your name" : 'Harap isi nama anda' }}
                </span>
                <div class="form-group">
                  <!-- <input type="name" v-model="submit.confirmation" class="form-control" id="name" placeholder="Masukkan Nama Anda" autocomplete="off" required> -->
                  <select v-model="submit.confirmation" class="form-control" >
                    <option value="" disabled selected>
                      {{ config.language === 1 ? "Confirmation of attendance" : 'Konfirmasi Kehadiran' }}
                    </option>
                    <option value="hadir">{{ config.language === 1 ? "Attend" : 'Hadir' }}</option>
                    <option value="mungkin">{{ config.language === 1 ? "Maybe Attend" : 'Mungkin Hadir' }}</option>
                    <option value="tidak">{{ config.language === 1 ? "Not Attend" : 'Tidak Hadir' }}</option>
                  </select>
                </div>
                <span v-if="errors.confirmation" style="margin-bottom:10px" class="badge badge-danger">
                  {{ config.language === 1 ? "Please fill your attendance confirmation" : 'Harap isi konfirmasi kehadiran anda' }}
                </span>
                <div class="form-group">
                  <label for="name" class="sr-only">Pesan</label>
                  <textarea type="name" v-model="submit.comment" class="form-control" id="pesan" :placeholder="config.language === 1 ? 'Message' : 'Pesan'" autocomplete="off" required cols="50" rows="10"></textarea>
                </div>
                <!-- <span v-if="errors.comment" style="margin-bottom:10px" class="badge badge-danger">
                  Harap isi pesan anda
                </span> -->
              </div>
              <div class="col-md-4 col-md-offset-4">
                <button type="submit" class="btn btn-default btn-block" @click.prevent="post" >{{ config.language === 1 ? "Send Hopes" : 'Kirim Ucapan' }}</button>
              </div>
            </form>
          </div>
        </div>
        <div class="row animate-box">
        <div class="col-md-10 col-md-offset-1 widget" style="margin-top:10px;">
          <div class="col-md-8 col-md-offset-2">
            <ul class="list-group">
              <li v-for="h in hopes" :key="h.id" class="list-group-item">
                <div class="row">
                  <div class="col-xs-3 col-md-2">
                    <img src="assets/images/wedding-rings.png" class="img-responsive" style="border:2px solid #f0ad4e; border-radius:50%;" alt="" />
                  </div>
                  <div class="col-xs-9 col-md-10 alert alert-warning">
                    <div >
                      <label style="font-size:18px;" for="one">{{h.name}}</label>
                    </div>
                    <div>
                        <p v-if="h.confirmation == 'hadir'" style="font-size:12px;font-style: oblique;">{{ config.language === 1 ? "Attend" : 'Hadir' }}</p>
                        <p v-if="h.confirmation == 'mungkin'" style="font-size:12px;font-style: oblique;">{{ config.language === 1 ? "Maybe Attend" : 'Mungkin Hadir' }}</p>
                        <p v-if="h.confirmation == 'tidak'" style="font-size:12px;font-style: oblique;">{{ config.language === 1 ? "Not Attend" : 'Tidak Hadir' }}</p>
                      </div>
                    <div class="comment-text">
                      <p style="font-size:16px;"> "{{h.comment}}"</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      </div>
    </div>
    
    
    <!-- <Protocol :config="config"/> -->
    
    <div id="fh5co-couple-story">
      <div class="container">
        <div class="row">
          <div class="display-t">
            <div class="display-tc">
              <div class="col-md-10 col-md-offset-1">
                <div style="z-index: 1000;" class="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
                    <img style="width:auto; margin-bottom:-90px;" src="/assets/images/Asset-6-300x135.png" alt="">
                </div>
                <div class="col-md-6 col-sm-6 col-md-offset-3 text-center">
                  <div class="event-wrap animate-box">
                   <div class="card text-center">
                    <div class="card-body">
                      <p class="card-text" style="margin-top:100px; color: #000000;">
                        {{ config.language === 1 ? "It is an honor and happiness for us as a family if you are willing to be present to give your blessing to the bride and groom. We thank you for your presence and blessings." : 'Merupakan suatu kehormatan dan kebahagiaan bagi kami sekeluarga apabila Bapak/Ibu/Saudara/i berkenan hadir untuk memberikan doa restu kepada kedua mempelai. Atas kehadiran serta doa restu, kami ucapkan terima kasih.' }}
                      </p>
                      <h4 style="font-family: 'Oleo Script', Sans-serif;">
                        {{ config.language === 1 ? "Happy from the our Big Family" : 'Turut Berbahagia Segenap Keluarga Besar' }}
                      </h4>
                      <h1 v-if="client.hajat == 'wanita'">{{client.nama_wanita}}</h1>
                      <h1 v-if="client.hajat == 'pria'">{{client.nama_pria}}</h1>
                      <h1>&amp;</h1>
                      <h1 style="margin-bottom:80px;" v-if="client.hajat == 'wanita'">{{client.nama_pria}}</h1>
                      <h1 style="margin-bottom:80px;" v-if="client.hajat == 'pria'">{{client.nama_wanita}}</h1>
                      
                    </div>
                  </div>
                  </div>
                </div>
                <div class="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
                    <img style="width:auto; margin-top:-100px;" src="/assets/images/Asset-7-300x135.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <footer class="fh5co-bg" style="background-image:url(../assets/images/image1.jpg);">
      <div class="container">

        <div class="row copyright">
          <div class="col-md-12 text-center">
            <!-- <p style="margin-top:10px;"> -->
            <small style=" margin-top:10px; font-family: 'Oleo Script', Sans-serif; color: #fff;">
                Developed by <a href="" style="color: #fff;">It's Your Day Teams</a>
            </small>
            <!-- </p> -->
          </div>
          <div class="col-md-12 text-center">
            <ul class="fh5co-social-icons" style="margin-bottom:10px;">
              <li><a href="https://www.instagram.com/itsyourday_digitalinvitation/"><i class="icon-instagram"></i></a></li>
            </ul>
          </div>
        </div>

      </div>
	</footer>
    
    
    
    <Modal
      v-show="isModalVisible"
      @close="closeModal"
      :client='client'
      :guest='guest'
      :config="config"
    />
    <audio :src="'https://admin.itsyourdayofficial.com/song/'+ audio" ref="audioElm" loop="loop"></audio>

    <div class="icon-bar">
      <button class="play" @click="play" v-if="playing"><i class="icon-pause"></i></button>
      <button class="play" @click="play" v-else><i class="icon-play"></i></button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onServerPrefetch, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useHead } from '@unhead/vue';

// Mulai dengan nilai null sehingga komponen tahu data belum ada.
const clientForServer = ref(null);

// Dapatkan akses ke route dan router.
const route = useRoute();
const router = useRouter();

// Dapatkan instance global (misalnya untuk menggunakan $api yang sudah disuntikkan).
const { proxy } = getCurrentInstance();

/*
  Gunakan useHead dengan computed properties untuk mengatur meta tags.
  Nilai default kosong sampai data API didapat.
*/
// === URL OG image 1200×630 JPEG (via proxy resize), dengan fallback ===
    const ogImageUrl = computed(() => {
    const original =
      clientForServer.value && clientForServer.value.foto_cover
        ? `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`
        : null;

    // 1200x630 (1.91:1) + smart crop agar pusat perhatian tetap tampil rapi
    return original
      ? `https://images.weserv.nl/?url=${encodeURIComponent(original.replace(/^https?:\/\//, ''))}&w=600&h=550&fit=cover&a=center&output=jpg&q=85`
      : `https://itsyourdayofficial.com/og/default-1200x630.jpg`; // pastikan file ini ada & publik
  });


  // === Meta OG (tetap 1200x630 untuk WhatsApp) ===
  useHead({
    title: computed(() => {
      if (clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria) {
        return clientForServer.value.hajat === 'wanita'
          ? `Wedding Invitation ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : `Wedding Invitation ${clientForServer.value.nama_pria} & ${clientForServer.value.nama_wanita}`;
      }
      return "";
    }),
    meta: [
      { key: "og:title", property: "og:title", content: computed(() =>
        clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria
          ? `Wedding of ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : ""
      )},
      { key: "og:description", property: "og:description", content: computed(() =>
        clientForServer.value && clientForServer.value.nama_wanita && clientForServer.value.nama_pria
          ? `Mohon doa dan restunya atas pernikahan kami ${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
          : ""
      )},
      { key: "og:url", property: "og:url", content: "https://admin.itsyourdayofficial.com" },
      { key: "og:type", property: "og:type", content: "website" },

      // ==== OG image (WA / FB) ====
      { key: "og:image", property: "og:image", content: ogImageUrl },
      { key: "og:image:width",  property: "og:image:width",  content: "1200" },
      { key: "og:image:height", property: "og:image:height", content: "630" },
      { key: "og:image:type",   property: "og:image:type",   content: "image/jpeg" },
    ],
    link: [
      {
        rel: "icon",
        href: computed(() => {
          if (clientForServer.value && clientForServer.value.foto_cover) {
            return `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`;
          }
          return "";
        }),
      },
    ],
  });

/*
  Fungsi fetchclientData() melakukan API call untuk mengambil data berdasarkan route.
  Kami menangani parameter 'to' dengan cara:
  1. Mengambil nilai dari route (tersedia baik pada SSR maupun client-side).
  2. Decode parameter tersebut.
  3. Validasi menggunakan regex: format yang valid adalah hanya alfanumerik dengan tanda strip sebagai pemisah (misalnya, "Juju-Dan-Suami").
     Jika tidak memenuhi (misalnya hanya satu kata atau mengandung spasi/karakter lain), maka parameter dikosongkan.
  4. Menentukan URL template berdasarkan lingkungan (SSR atau client).
*/
async function fetchclientData() {
  let toParam = route.query.to || "";
  if (toParam) {
    const decodedTo = decodeURIComponent(toParam);
    // Regex valid: minimal dua kata (alfanumerik) yang dipisahkan oleh strip, tanpa spasi atau karakter khusus lain.
    const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
    if (!validDBPattern.test(decodedTo)) {
      // Bila tidak sesuai, parameter dikosongkan untuk API request.
      toParam = "";
    } else {
      // Jika valid, gunakan nilai decoded.
      toParam = decodedTo;
    }
  }

  // Jika window tidak tersedia (SSR), gunakan URL fallback.
  const templateUrl =
    typeof window !== "undefined"
      ? window.location.origin + "/"
      : "https://eternal.itsyourdayofficial.com/"; //host
    // : "http://localhost:8083/";  //local

  try {
    // console.log("Memulai fetch API dengan slug: ", route.params.slug);
    // console.log("Template URL:", templateUrl);
    // console.log("Param to:", toParam);
    const response = await proxy.$api.get('/' + route.params.slug, {
      params: {
        to: toParam,
        template: templateUrl,
      },
    });
    if (response.data.data) {
      clientForServer.value = response.data.data;
    } else {
      router.push({ name: 'NotFoundPage' });
    }
  } catch (error) {
    console.error("Error fetching clientForServer data:", error);
  }
}

/*
  onServerPrefetch() hanya dipanggil saat SSR.
  Server akan menunggu Promise yang dikembalikan sehingga data sudah tersedia sebelum render.
*/
onServerPrefetch(async () => {
  await fetchclientData();
});

/*
  onMounted() adalah fallback untuk rendering client-side.
  Jika data belum ada (misalnya karena navigasi client-side), API dipanggil ulang.
*/
onMounted(async () => {
  if (!clientForServer.value) {
    await fetchclientData();
  }
});
</script>

<script>
import Header from '../components/Header.vue'
import Couple from '../components/Couple.vue'
import Event from '../components/Event.vue';
import Galerry from '../components/Galerry.vue';
import Modal from '../components/Modal.vue';
import Confirmation from '../components/Confirmation.vue';
import Quotes from '../components/Quotes.vue';
import Angpao from '../components/Angpao.vue';
import Protocol from '../components/Protocol.vue';
import AlsoInvitation from '../components/AlsoInvite.vue';
import VueHorizontal from "vue-horizontal";
// import Location from '../components/MapsLocation.vue';
import moment from 'moment';
export default {
  name: 'Home',
  components: {
    // HelloWorld
    Header,
    Couple,
    Event,
    Galerry,
    Modal,
    Confirmation,
    Quotes,
    Angpao,
    Protocol,
    AlsoInvitation,
    VueHorizontal,
    // Location,
  },
data() {
    return{
        client: {},
        guest: {},
        gallery: [],
        lightboxVisible: false,
        currentIndex: 0,
        Lightbox: null,
        autoScrollInterval: null, // untuk menyimpan ID interval auto-scroll
        img1: '',
        img2: '',
        img3: '',
        img4: '',
        moment: moment,
        isModalVisible: true,
        playing: true,
        audio: '',
        errors: {},
        date: '',
        now: 0,
        count: 0,
        config: {},
        story: {
            title1: '',
            description1: '',
            date1: '',
            month1: '',
            year1: '',
            media1: '',
            type1: '',
            order1: '',
            rangeTime1: '',
            title2: '',
            description2: '',
            date2: '',
            month2: '',
            year2: '',
            media2: '',
            type2: '',
            order2: '',
            rangeTime2: '',
            title3: '',
            description3: '',
            date3: '',
            month3: '',
            year3: '',
            media3: '',
            type3: '',
            order3: '',
            rangeTime3: '',
            title4: '',
            description4: '',
            date4: '',
            month4: '',
            year4: '',
            media4: '',
            type4: '',
            order4: '',
            rangeTime4: '',
            title5: '',
            description5: '',
            date5: '',
            month5: '',
            year5: '',
            media5: '',
            type5: '',
            order5: '',
            rangeTime5: '',
        },
        name: '',
        picked: '',
        submit: {
            client_id: '',
            name: '',
            comment: '',
            confirmation: '',
        },
        hopes: {},
        hasPrev: false,
        hasNext: true,
        alsoInvite: {},
        showGallery: false
    }
  },
  mounted(){

    import("vue-easy-lightbox")
    .then(module => {
      this.Lightbox = module.default;
    })
    .catch(err => {
      console.error("Gagal memuat vue-easy-lightbox:", err);
    });

    if(this.isModalVisible === true){
        document.body.style.overflow = "hidden"; 
        document.body.style.bottom = "0";
        document.body.style.left= "0";
        document.body.style.right= "0";
        document.body.style.top= "0";      
        document.body.style.position= "fixed";
    } 

    if (typeof window !== 'undefined') {
        window.addEventListener('scroll', this.checkScroll);
        // Ambil query raw (encoded) dari URL
        let rawToParam = this.getOriginalQueryParam('to') || '';
        if (rawToParam) {
            // decode untuk validasi
            const decodedTo = decodeURIComponent(rawToParam);
            /*  
            Kita gunakan regex untuk menentukan format yang valid.
            Format valid adalah:
                - Satu atau lebih kata (hanya A-Z atau a-z atau angka) 
                - Dipisah dengan tanda strip (misalnya: Kata1-Kata2 atau kata1-kata2-kata3)
            Contoh:
                • "Juju-Dan-Suami" → valid.
                • "Desty" (hanya 1 kata) → tidak valid.
                • "Ibu. Desty - Suami" → tidak valid karena mengandung spasi, titik, atau karakter lain.
            */
            const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
            if (!validDBPattern.test(decodedTo)) {
                // Jika tidak memenuhi pola, gunakan nilai kosong untuk request API.
                rawToParam = '';
            }
        }
        
        // Gunakan nilai template dari window.location.origin (client-side)
        const template = window.location.origin + "/";
        
        // Lakukan API request menggunakan parameter yang telah divalidasi
        this.$api.get('/' + this.$route.params.slug, {
            params: {
                to: rawToParam,
                template: template,
            }
        })
        .then(response => {
            if (!response.data.data) {
                this.$router.push({ name: 'NotFoundPage' });
                return;
            }
            var currentUrl = window.location.href;
            this.client = response.data.data;
            this.gallery = response.data.data.gallery;
            this.pages = this.gallery.length;
            this.img1 = response.data.data.gallery[0];
            this.img2 = response.data.data.gallery[1];
            this.img3 = response.data.data.gallery[2];
            this.img4 = response.data.data.gallery[3];
            if (currentUrl.includes(this.client.template) == false) {
                this.$router.push({ name: 'NotFoundPage' });
            }
            this.guest = response.data.data;
            this.audio = response.data.data.song;
            
            this.date = moment(response.data.data.tgl_akad).format('MMMM DD, YYYY hh:mm:ss a');

            if (response.data.data.config[0].countdown == 1) {
                this.date = moment(response.data.data.tgl_resepsi).format('MMMM DD, YYYY hh:mm:ss a');
            } else if (this.client.tgl_unduh_mantu !== null) {
                this.date = moment(response.data.data.tgl_unduh_mantu).format('MMMM DD, YYYY hh:mm:ss a');
            }            
            else{
                this.date = moment(response.data.data.tgl_akad).format('MMMM DD, YYYY hh:mm:ss a');
            }
            this.config = response.data.data.config[0];
            this.story.title1 = response.data.data.story[0];
            this.story.description1 = response.data.data.story[0];
            this.story.date1 = response.data.data.story[0];
            this.story.month1 = response.data.data.story[0];
            this.story.year1 = response.data.data.story[0];
            this.story.media1 = response.data.data.story[0];
            this.story.type1 = response.data.data.story[0];
            this.story.order1 = response.data.data.story[0];
            this.story.rangeTime1 = response.data.data.story[0];
            this.story.title2 = response.data.data.story[1];
            this.story.description2 = response.data.data.story[1];
            this.story.date2 = response.data.data.story[1];
            this.story.month2 = response.data.data.story[1];
            this.story.year2 = response.data.data.story[1];
            this.story.media2 = response.data.data.story[1];
            this.story.type2 = response.data.data.story[1];
            this.story.order2 = response.data.data.story[1];
            this.story.rangeTime2 = response.data.data.story[1];
            this.story.title3 = response.data.data.story[2];
            this.story.description3 = response.data.data.story[2];
            this.story.date3 = response.data.data.story[2];
            this.story.month3 = response.data.data.story[2];
            this.story.year3 = response.data.data.story[2];
            this.story.media3 = response.data.data.story[2];
            this.story.type3 = response.data.data.story[2];
            this.story.order3 = response.data.data.story[2];
            this.story.rangeTime3 = response.data.data.story[2];
            this.story.title4 = response.data.data.story[3];
            this.story.description4 = response.data.data.story[3];
            this.story.date4 = response.data.data.story[3];
            this.story.month4 = response.data.data.story[3];
            this.story.year4 = response.data.data.story[3];
            this.story.media4 = response.data.data.story[3];
            this.story.type4 = response.data.data.story[3];
            this.story.order4 = response.data.data.story[3];
            this.story.rangeTime4 = response.data.data.story[3];
            this.story.title5 = response.data.data.story[4];
            this.story.description5 = response.data.data.story[4];
            this.story.date5 = response.data.data.story[4];
            this.story.month5 = response.data.data.story[4];
            this.story.year5 = response.data.data.story[4];
            this.story.media5 = response.data.data.story[4];
            this.story.type5 = response.data.data.story[4];
            this.story.order5 = response.data.data.story[4];
            this.story.rangeTime5 = response.data.data.story[4];
            this.submit.client_id = this.client.id;
            // Update hasNext property based on whether gallery has items
            this.hasNext = this.gallery.length > 1;
            this.alsoInvite = response.data.data.also_invite;
            this.timer_loop();
            this.modifiedDate = Math.trunc(Date.parse(this.date) / 1000);
            this.$api.get('comment/' + this.client.id)
                .then(response => {
                    this.hopes = response.data.data;
                })
        })
        .catch(error => {
            // this.$router.push({ name: 'NotFoundPage' });
            console.log(error.response.data);
        });

        // Contoh mengatur posisi awal gallery (jika diperlukan)
        this.$refs.horizontal.scrollToIndex(1);

        // Mulai auto-scroll jika gallery terlihat
        if (this.showGallery) {
            this.startAutoScroll();
        }
    }
  },
  methods:{
    timer_loop() {
      this.count++;
      this.now = Math.trunc(new Date().getTime() / 1000);
      if (this.count < 200 && this.modifiedDate > this.now) {
        setTimeout(this.timer_loop, 1000);
      } else {
        this.count = 0;
      }
    },
    getOriginalQueryParam(paramName) {
        // Pastikan hanya mencoba mengakses window jika ada
        if (typeof window === 'undefined') return null;
        const queryString = window.location.search;
        const regex = new RegExp(`[?&]${paramName}=([^&]+)`);
        const matches = regex.exec(queryString);
        return matches && matches.length > 1 ? matches[1] : null;
    },

    checkScroll() {
      const galleryElement = document.querySelector('.elementor-element-6b397287');
      if (galleryElement) {
        const rect = galleryElement.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
        this.showGallery = isVisible;
        if (isVisible && !this.autoScrollInterval) {
          this.startAutoScroll();
        } else if (!isVisible && this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval);
          this.autoScrollInterval = null;
        }
      }
    },
    startAutoScroll() {
      // Pastikan interval sebelumnya telah dihapus
      if (this.autoScrollInterval) clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = setInterval(() => {
        // Jika masih ada gambar selanjutnya, panggil next dengan dummy event
        if (this.hasNext) {
          this.next({ stopPropagation: () => {} });
        } else {
          // Jika tidak ada gambar next, reset ke posisi awal (misalnya index 0)
          this.$refs.horizontal.scrollToIndex(0);
        }
      }, 5000);
    },

    play: function() {
      var a = this.$refs.audioElm;
      if (a.paused) {
        a.play();
        this.playing = true;
      } else {
        a.pause();
        this.playing = false;
      }
    },
    closeModal() {
      this.isModalVisible = false;
      var a = this.$refs.audioElm;
      a.play();
      this.playing = true;

      if(this.isModalVisible == false){
        document.body.style.position= "static";
        document.body.style.overflow = "auto"; 
      }
    },
    post(){
      this.$api.post('comment', this.submit)
      .then(response =>{
          this.success = response.data.success
          this.submit.name = '';
          this.submit.comment = '';
          this.submit.confirmation = '';
          this.$api.get('comment/' + this.client.id)
          .then(response => { 
            this.hopes = response.data.data;
          })
          console.log(response)
      })
      .catch(error => {
          if (error.response.status === 401) {
            this.errors = error.response.data.errors;
          }
      });
    },
    openLightbox(index) {
      this.currentIndex = index;
      this.lightboxVisible = true;
    },
    closeLightbox() {
      this.lightboxVisible = false;
    },
    prev(event) {
      if (this.$refs.horizontal && typeof this.$refs.horizontal.prev === 'function') {
        this.$refs.horizontal.prev(event);
      } else {
        console.error('Horizontal ref or prev method is not defined');
      }
    },
    next(event) {
      if (this.$refs.horizontal && typeof this.$refs.horizontal.next === 'function') {
        this.$refs.horizontal.next(event);
      } else {
        console.error('Horizontal ref or next method is not defined');
      }
    },
    onScroll({ hasPrev, hasNext }) {
        this.hasPrev = hasPrev
        this.hasNext = hasNext
    },
  },
  computed:{
    imageList() {
      return this.gallery.map(item => "https://admin.itsyourdayofficial.com/gallery/" + item.file);
    },
    seconds() {
        const result = (this.modifiedDate - this.now) % 60;
        return result < 0 ? 0 : result;
    },
    minutes() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60) % 60;
        return result < 0 ? 0 : result;
    },
    hours() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60) % 24;
        return result < 0 ? 0 : result;
    },
    days() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60 / 24);
        return result < 0 ? 0 : result;
    },
    modifiedDate : function(){
      return Math.trunc(Date.parse(this.date) / 1000)
    }
  },
  watch : {
    gallery(newVal) {
      this.pages = newVal.length;
    },
    showGallery(newVal) {
      // Jika gallery terlihat, auto-scroll akan berjalan melalui startAutoScroll
      if (newVal && !this.autoScrollInterval) {
        this.startAutoScroll();
      } else if (!newVal && this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    }
  },
}
</script>

<style >

    #map {
        height: 100%;
    }

</style>

<style scoped>
.item {
    width: 250px;
    /* padding: 32px 32px 24px 32px;
  background: #f1f1f1; */
    margin-right: 20px;
    height: 350px;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    position: relative;
    /* added */
}

.justify-content-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
}
.gallery {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 20px;
    z-index: 0;
    object-fit: cover;
    margin-top: 50px;
}

.gallery:after {
    border-radius: 20px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f1bcb3;
    opacity: 0;
    content: '';
    z-index: -1;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.pagination {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}

header .pagination {
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

nav>button {
    padding: 0.5rem;
    border-radius: 0.5rem;
    border: none;
    outline: none;
    margin: 0.25rem;
}

nav>button.active {
    color: #ffffff;
    border-color: #ffffff;
    background-color: #e79552;
}

nav>button.inactive {
    color: #ffffff;
    border-color: #ffffff;
    background-color: #f3b684;
}

nav>button:focus {
    outline: none;
}

nav>button>svg {
    height: 1.5rem;
    width: 1.5rem;
    fill: currentColor;
}

.magnifier-icon {
  position: absolute;
  bottom: 8px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5); /* Latar belakang semi-transparan */
  color: white;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 0.8em;
  cursor: pointer;
}
</style>